<template>
  <div style="background-color: #f1f1f1; min-height: 100vh; box-sizing: border-box">
    <div  class="backIcon">
     <img src="/static/image/icon_back.b6d392fbff2eec45063fd4d6c0c5c597.png"alt="" @click="$router.go(-1)">
    </div>
    <!-- title -->
    <div style="padding: 0 18px;background: url('/static/image/style_2_topbg.avif');background-size: 100%;position: relative;">
      <div style="    position: absolute;left: 0;opacity: .15;z-index: 1;width: 100%;height: 100%;background: linear-gradient(to bottom, #c78a33, transparent);"></div>
      <div style="position: relative;z-index: 9;">
      <div class="mineTop"  v-if="$store.state.token">
        <div class="kefus" @click="$parent.openKefu()"><img src="/static/style/icon_dt_1kf.png" /><span>客服</span></div>
        <div class="kefus" @click="$parent.goNav('/message')"><img src="/static/style/icon_dt_1grbb.avif" /><span>消息</span></div>
        <div class="kefus" @click="$parent.goNav('/userInfo')"><img src="/static/style/icon_dt_1sz.avif" /><span>个人资料</span></div>
      </div>
      <!-- user -->
       <div class="lesf" v-if="$store.state.token" >
            <img :src="$store.state.userInfo.avatar ? $store.state.userInfo.avatar : '/static/image/imageAvatar02@3x.png'" alt="" class="img"/>
            <input v-if="$store.state.token" class="inputsw" type="file" @change="onchangemd" single accept="image/gif,image/png" />
            <img :src="`/static/style/vip${$store.state.userInfo.vip}.png`" alt="" class="vipji" />
          </div>
      <div class="usersg">
        <div class="user-main">
          
          <div class="center" v-if="$store.state.token" >
            <div class="name">
              {{ $store.state.userInfo.username }} 
              <svg width="1em" height="1em" @click="clickCopy($store.state.userInfo.username)" fill="currentColor" class="" viewBox="0 0 20.727 24">
                <path id="4e0f559826fd31bb0ad8a4c5934c2092-comm_icon_copy" d="M1801.586,16.829a1.094,1.094,0,0,1-1.1-1.093V-1.781a1.094,1.094,0,0,1,1.1-1.093,1.094,1.094,0,0,1,1.095,1.093V14.643h13.136a1.093,1.093,0,1,1,0,2.185Zm4.305-4.3a1.1,1.1,0,0,1-1.1-1.093V-6.078a1.094,1.094,0,0,1,1.1-1.093h8.759a1.094,1.094,0,0,1,.773.32l5.474,5.463a1.091,1.091,0,0,1,.321.773V11.439a1.094,1.094,0,0,1-1.1,1.093Zm1.094-2.185h12.044V1.569h-5.474A1.094,1.094,0,0,1,1812.46.476V-4.986h-5.475Z" transform="translate(-1800.491 7.171)"></path>
              </svg>
              <!-- <img :src="`/static/style/vip${$store.state.userInfo.vip}.png`" alt="" /> -->
            </div>
            <div v-if="$store.state.token" class="dat" @click="$parent.goNav('/userInfo')">加入{{ $store.state.appInfo.title }}第{{ $store.state.userInfo.joinday }}天</div>
          </div>
          <div class="btn-group"  v-if="!$store.state.token">
            <button  class="btn register" @click="$router.push('/login?type=1')"> 注册 </button>
            <button class="btn login" @click="$router.push('/login')">登录</button>
          </div>
          
        </div>
        <img class="rig" v-if="$store.state.token" @click="$parent.goNav('/userInfo')" src="/static/style/icoArrowGrey@2x.abc43ab099390c4587d33290a76fc15e.png" alt="" />
      </div>
      <div class="meys" v-if="$store.state.token">
        <!-- <div class="lefs">
          <img src="/static/image/wallet.png" alt="" />
          <span>中心钱包</span>
          <div class="imsg" @click="$parent.getUserInfoShowLoding()">
            <img src="/static/style/refresh_2.98852cef4dfc05494e3f32a99e17d124.png" />
          </div>
        </div> -->
        <div class="meysf"  @click="$parent.getUserInfoShowLoding()">
          <span class="meyq">￥</span>
          <span class="meyp"> {{ $store.state.userInfo.balance }}</span>
          <i class="lobby-image lobby-image lobby-image--skeleton animate__spin animate__infinite" data-load-strategy="loading-set@0:lazy@0" data-status="success" data-thumb="0" data-id="49b40ee4-6725-4e37-86c5-c4a3f952a1b5" data-src="/siteadmin/skin/lobby_asset/1-0-common/web/common/comm_icon_sx.svg" style="display: inline-flex; justify-content: center; align-items: center;"><svg width="1.5em" height="1.5em" fill="#866638" class="" viewBox="0 0 24 25.144">
  <path id="8c340ce2cd6f0d7c93afeea157d09bb4-comm_icon_sx" d="M1520.314-127.2l5.058-9.146,2.1,3.9a10.844,10.844,0,0,0,4.845-9.038c0-3.028-2-6.031-4-8,3.919,1.639,7.43,5.773,7.43,10.285a10.856,10.856,0,0,1-6.549,9.964l1.977,3.179Zm-8.572-10.858a10.86,10.86,0,0,1,6.548-9.965l-1.976-3.178,10.857,1.142-5.06,9.147-2.095-3.9a10.842,10.842,0,0,0-4.847,9.039c0,3.028,2,6.031,4,8C1515.255-129.409,1511.743-133.543,1511.743-138.055Z" transform="translate(-1511.743 151.198)"></path>

</svg></i>
        </div>

        
      </div>
      <div class="dow">
          <div class="dow_list" @click="$parent.goNav('/withdrawal')">
           <img src="/static/style/icon_dt_1tx.avif" alt="">
            <p>提现</p>
          </div>
          <div class="dow_list" @click="$parent.goNav('/recharge')">
            <div class="ui-badge ui-badge--top-right ui-badge--fixed" style="color: rgb(255, 255, 0); z-index: 0; --badge-bg-color: var(--skin__accent_2);"><!----><div class="ui-badge__content">送2%</div></div>
            <img src="/static/style/icon_dt_1cz.avif" alt="">
            <p>充值</p>
          </div>
        </div>
      <div style="position: relative;background: #f1f1f1;border-radius: 6px;margin-bottom:16px;">
        <van-swipe indicator-color="#fff" :autoplay="2000">
          <van-swipe-item v-for="(item, index) in bannerList" :key="index">
            <img :src="item" style="width: 100%" alt="" />
          </van-swipe-item>
        </van-swipe>
      </div>


      <div class="vipousf">
        <div class="box" @click="$parent.goNav('/vip')">
          <img src="/static/image/vipnew.png" alt="" />
          <div>
            <div class="nsgs">VIP特权</div>
            <div class="nsgsss">VIP PRIVILEGE</div>
          </div>
        </div>
        <div class="shu"></div>
        <div class="box" @click="$parent.goNav('/activity')">
          <img src="/static/image/giftnew.png" alt="" />
          <div>
            <div class="nsgs">豪礼赠送</div>
            <div class="nsgsss">SPREE ACTIVITY</div>
          </div>
        </div>
      </div>
    </div>
    </div>
    <div class="uslis">
      <div style="box-sizing: border-box; padding: 0 12px">
        <div style="height: 24px"></div>
        <!-- <div class="thbs">
          <div class="lis" @click="$parent.goNav('/money')">
            <img src="/static/image/walletnew.png" alt="" />
            <span>我的钱包</span>
          </div>
          <div class="lis" @click="$parent.goNav('/transRecord')">
            <img src="/static/image/transactionnew.png" alt="" />
            <span>交易记录</span>
          </div>
          <div class="lis" @click="$parent.goNav('/betRecord')">
            <img src="/static/image/betnew.png" alt="" />
            <span>投注记录</span>
          </div>
          <div class="lis" @click="$parent.goNav('/userCent')">
            <img src="/static/image/settingnew.png" alt="" />
            <span>账户设置</span>
          </div>
        </div> -->
        <div class="bosfs">
          <div class="hgsw" @click="$parent.goNav('/money')">
            
            <img class="firsimg" src="/static/image/mine/1.png" alt="" />
            <span class="tit">我的钱包</span>
            <span class="tisf"></span>
            <!-- <img class="rigiong" src="/static/style/icoArrowGrey@2x.abc43ab099390c4587d33290a76fc15e.png" alt="" /> -->
          </div>
          <div class="hgsw" @click="$parent.goNav('/transRecord')">
            <img class="firsimg" src="/static/image/mine/2.png" alt="" />
            <span class="tit">交易记录</span>
            <span class="tisf"></span>
            <!-- <img class="rigiong" src="/static/style/icoArrowGrey@2x.abc43ab099390c4587d33290a76fc15e.png" alt="" /> -->
          </div>
          <div class="hgsw" @click="$parent.goNav('/betRecord')">
            <img class="firsimg" src="/static/image/mine/3.png" alt="" />
            <span class="tit">投注记录</span>
            <span class="tisf"></span>
            <!-- <img class="rigiong" src="/static/style/icoArrowGrey@2x.abc43ab099390c4587d33290a76fc15e.png" alt="" /> -->
          </div>
          <div class="hgsw" @click="$parent.goNav('/userCent')">
            <img class="firsimg" src="/static/image/mine/4.png" alt="" />
            <span class="tit">账户设置</span>
            <span class="tisf"></span>
            <!-- <img class="rigiong" src="/static/style/icoArrowGrey@2x.abc43ab099390c4587d33290a76fc15e.png" alt="" /> -->
          </div>
          <div class="hgsw" @click="$parent.goNav('/message')">
            <img class="firsimg" src="/static/image/mine/5.png" alt="" />
            <span class="tit">消息中心</span>
            <span class="tisf"></span>
            <!-- <img class="rigiong" src="/static/style/icoArrowGrey@2x.abc43ab099390c4587d33290a76fc15e.png" alt="" /> -->
          </div>

          <div class="hgsw" @click="$parent.goNav('/fanshui')">
            <img class="firsimg" src="/static/image/mine/6.png" alt="" />
            <span class="tit">返水中心</span>
            <span class="tisf"></span>
            <!-- <img class="rigiong" src="/static/style/icoArrowGrey@2x.abc43ab099390c4587d33290a76fc15e.png" alt="" /> -->
          </div>
          <div class="hgsw" @click="$parent.goNav('/activityRecord')">
            <img class="firsimg" src="/static/image/mine/7.png" alt="" />
            <span class="tit">活动记录</span>
            <span class="tisf"></span>
            <!-- <img class="rigiong" src="/static/style/icoArrowGrey@2x.abc43ab099390c4587d33290a76fc15e.png" alt="" /> -->
          </div>
          <div class="hgsw" @click="$parent.goNav('/welfare')">
            <img class="firsimg" src="/static/image/mine/8.png" alt="" />
            <span class="tit">福利中心</span>
            <span class="tisf"></span>
            <!-- <img class="rigiong" src="/static/style/icoArrowGrey@2x.abc43ab099390c4587d33290a76fc15e.png" alt="" /> -->
          </div>
          <div class="hgsw" v-if="$store.state.userInfo.isagent == 0" @click="$parent.goNav('/applyagent')">
            <img class="firsimg" src="/static/image/mine/9.png" alt="" />
            <span class="tit">合营计划</span>
            <span class="tisf"></span>
            <!-- <img class="rigiong" src="/static/style/icoArrowGrey@2x.abc43ab099390c4587d33290a76fc15e.png" alt="" /> -->
          </div>
          <div class="hgsw" v-if="$store.state.userInfo.isagent == 1" @click="$parent.goNav('/gamePage?dailiD=1')">
            <img class="firsimg" src="/static/image/mine/12.png" alt="" />
            <span class="tit">代理登录</span>
            <span class="tisf"></span>
            <!-- <img class="rigiong" src="/static/style/icoArrowGrey@2x.abc43ab099390c4587d33290a76fc15e.png" alt="" /> -->
          </div>
          <div class="hgsw" @click="$parent.goNav('/app')">
            <img class="firsimg" src="/static/image/mine/10.png" alt="" />
            <span class="tit">app下载</span>
            <span class="tisf"></span>
            <!-- <img class="rigiong" src="/static/style/icoArrowGrey@2x.abc43ab099390c4587d33290a76fc15e.png" alt="" /> -->
          </div>
          <div class="hgsw" @click="$parent.goNav('/boutBallBet')">
            <img class="firsimg" src="/static/image/mine/11.png" alt="" />
            <span class="tit">帮助中心</span>
            <span class="tisf"></span>
            <!-- <img class="rigiong" src="/static/style/icoArrowGrey@2x.abc43ab099390c4587d33290a76fc15e.png" alt="" /> -->
          </div>

          <!-- Hide logout button if not logged in -->
          <div  v-if="$store.state.token" class="hgsw" style="border: none" @click="$parent.outLogin">
            <img class="firsimg"  src="/static/image/mine/13.png" alt="" />
            <span class="tit">退出系统</span>
            <span class="tisf"></span>
            <!-- <img class="rigiong" src="/static/style/icoArrowGrey@2x.abc43ab099390c4587d33290a76fc15e.png" alt="" /> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'mine',
  data() {
    return {
      activitylistList: [],
      bfNum: 0,
      vipLis: [],
      bannerList:[
        '/static/image/01.png',
        '/static/image/02.png',
        '/static/image/03.png',
        '/static/image/04.png',
        '/static/image/05.png',
        '/static/image/06.png',
        '/static/image/07.png',
        '/static/image/08.png',
        '/static/image/09.png',
      ]
    };
  },
  created() {
    let that = this;
    that.activitylist();
    that.uservip();
  },
  methods: {
    clickCopy(text){
      let that = this
      // 创建临时的textarea
      const textArea = document.createElement('textarea');
      textArea.value = text;
      textArea.style.position = 'fixed';
      textArea.style.top = 0;
      textArea.style.left = 0;
      textArea.style.opacity = 0;
      document.body.appendChild(textArea);
      // 选中文本
      textArea.focus();
      textArea.select();

      try {

      // 尝试执行复制

      const successful = document.execCommand('copy');

      const msg = successful ? '成功复制到剪贴板！' : '复制失败，请手动复制！';

        that.showTost(2, msg);

      } catch (err) {

        that.showTost(2, 123);

      }

      // 移除临时元素

      document.body.removeChild(textArea);

    },
    showTost(type, title) {
      this.$parent.showTost(type, title);
    },
    onchangemd(e) {
      let that = this;

      console.log(e.target.files); //这个就是选中文件信息
      let formdata = new FormData();
      Array.from(e.target.files).map(item => {
        console.log(item);
        formdata.append('file', item); //将每一个文件图片都加进formdata
      });
      //  axios.post("接口地址", formdata).then(res => { console.log(res) })
      that.$parent.showLoading();

      that.$apiFun.post('/api/uploadimg', formdata).then(res => {
        that.$parent.hideLoading();

        that.$parent.getUserInfoShowLoding();
      });
    },
    uservip() {
      let that = this;
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/uservip', {})
        .then(res => {
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.vipLis = res.data;
            that.getbfNum();
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    getbfNum() {
      let that = this;
      let num = 0; //当前vip充值钱
      let vip = that.$store.state.userInfo.vip * 1; //当前vip等级
      that.vipLis.forEach((el, index) => {
        console.log();
        if (index == vip) {
          num = el.recharge * 1;
        }
      });
      let userMey = that.$store.state.userInfo.paysum * 1;
      let bfNum = userMey == 0 || num == 0 ? 0 : Math.round((userMey / num) * 100);
      that.bfNum = bfNum > 100 ? 100 : bfNum;
      console.log(111);
    },
    transall() {
      let that = this;
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/transall', {})
        .then(res => {
          that.$parent.showTost(0, res.message);
          that.$parent.getUserInfoShowLoding();
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    activitylist() {
      let that = this;
      let info = that.actType == '' ? {} : { type: that.actType };
      that.$parent.showLoading();
      that.$apiFun.post('/api/activitylist', info).then(res => {
        console.log(res);
        if (res.code !== 200) {
          that.$parent.showTost(0, res.message);
        }
        if (res.code === 200) {
          that.activitylistList = res.data.data;
        }
        that.$parent.hideLoading();
      });
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
// @import '../../../static/css/chunk-4deac3d0.11461b5f.css';
.mineTop {
  box-sizing: border-box;
  font-size: 16px;
  color: #5d75a2;
  text-align: center;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-top: 12px;
  .kefus {
    margin-left: 13px;
    height: 56px;
    font-size: 12px;

    img {
      width: 20px;
      display: block;
      margin:0 auto 3px;
    }
    span {
      text-align: center;
      padding-top: 6px;
      color: #666;
    }
  }
}
.lesf {
    // width: 60px;
    position: relative;
    display: flex;
    justify-content: center;
    .img {
      width: 60px;
      height: 60px;
      border-radius: 50%;
    }
    .vipji{
      position: absolute;
      width: 30px;
      bottom: 0;
    }
  }
.usersg {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #5d75a2;
  .user-main {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px 0 0 0;
    width: 100%;
  }
  
  .center {
    // flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    .name {
      font-size: 16px;
      font-weight: 700;
      margin-right: 20px;
      color: #866638;
      img {
        width: 30px;
        margin-left: 10px;
      }
    }
    .dat {
      font-size: 12px;
      // margin-top: 8px;
      color: #866638;
    }
  }
  .rig {
    width: 10px;
  }
}

.meys {
  display: flex;

  align-items: center;
  justify-content: center;
  margin: 0 auto;
  margin-top: 10px;
  padding: 0 12px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 94%;
  height: 36px;
  // background-image: url(/static/style/walletbg.27f1624304433214845615bf9bc121e3.png);
  background-repeat: no-repeat;
  background-position: top;
  background-size: 100% 100%;
  border-radius: 6px;
  color: #666;
  .lefs {
    display: flex;
    align-items: center;
    font-size: 12px;
    img {
      width: 18px;
    }
    span {
      padding: 0 6px;
    }
    .imsg {
      background: url(/static/image/refresh_1.png) no-repeat;
      background-size: 100% 100%;
      width: 14px;
      height: 14px;
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        width: 6px;
      }
    }
  }
  .meysf {
    font-size: 16px;
    font-weight: 700;
    display: flex;
    align-items: center;
    .meyq{
      font-size: 22px;
      
    }
    .meyp{
      font-size: 20px;
      border-bottom: 1px solid #666;
      padding-bottom: 2px;
      margin: 0 6px;
    }
  }
}

.vipousf {
  position: relative;
  display: flex;
  justify-content: space-between;
  background: url(/static/image/itembg01.9f4ff0731e793011f46663dbfdbfd903.9f4ff073.png) no-repeat;
  background-size: 100% 100%;
  margin: 0 auto;
  border-radius: 4px;
  width: 100%;
  height: 80px;
  -webkit-box-shadow: 0 0.04rem 0.2rem 0 rgb(93 114 162 / 11%);
  box-shadow: 0 0.04rem 0.2rem 0 rgb(93 114 162 / 11%);
  box-sizing: border-box;
  padding-top: 5px;
  padding-bottom: 10px;
  .box {
    display: flex;
    flex: 1;
    justify-content: center;
    align-items: center;
    img {
      width: 38px;
      margin-right: 10px;
    }
    .nsgs {
      font-weight: 600;
      font-size: 14px;
      color: #5d75a2;
    }
    .nsgsss {
      color: #a5a9b3;
      font-size: 8px;
      margin-top: 6px;
    }
  }
  .shu {
    width: 1px;
    display: block;
    background: rgba(170, 184, 209, 0.2);
    height: 100%;
  }
}
.uslis {
  // background: url(/static/image/bg2.16978ccb7fd03b3f524222a8425d3728.16978ccb.png) no-repeat;
  background-size: 100% 100%;
  width: 100%;
  margin-top: -20px;
  z-index: 200;
  position: relative;
  padding-bottom: 98px;
  .thbs {
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    padding: 0 16px;
    .lis {
      img {
        display: block;
        margin: 0 auto;
        width: 44px;
      }
      span {
        display: block;
        text-align: center;
        font-size: 12px;
        color: #5d75a2;
      }
    }
  }
  .bosfs {
    margin-top: 15px;
    border-radius: 4px;
    padding: 20px 12px 0 12px;
    box-sizing: border-box;
    width: 100%;
    background: #fff;
    // background: url(/static/image/list_bg.3577119be3c948988e7d77700fa0cc7d.3577119b.png) no-repeat;
    background-size: 100% 100%;
    -webkit-box-shadow: 0 0.04rem 0.2rem 0 rgb(93 114 162 / 11%);
    box-shadow: 0 0.04rem 0.2rem 0 rgb(93 114 162 / 11%);
    display: flex;
    flex-wrap: wrap;
    .hgsw {
      // display: flex;
      // align-items: center;
      // justify-content: space-between;
      box-sizing: border-box;
      // border-bottom: 1px solid #f5f0f0;
      margin-bottom: 20px;
      width: 25%;
      .firsimg {
        width: 28px;
        display: block;
        margin:0 auto 4px;
      }
      .tit {
        color: #666;
        // margin-left: 10px;
        text-align: center;
        display: block;
      }
      .tisf {
        // flex: 1;
        // margin: 0 12px;
        // color: #a2aec8;
        // text-align: right;
      }
      .rigiong {
        width: 6px;
      }
    }
  }
}

.login-btn {
  width: 80px;
  background: #866638;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 6px 22px;
  font-size: 15px;
  font-weight: 600;
  margin-left: 8px;
  align-self: center;
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
  box-shadow: 0 2px 8px rgba(255,184,77,0.08);
  outline: none;
  &:hover {
    transform: scale(1.05);
    box-shadow: 0 4px 16px rgba(255,184,77,0.15);
  }
}
.backIcon{
  position: absolute;
  left: 0;
  width: 40px;
  height: 44px;
  z-index: 9;
  img{
    width: 20px;
    height: 20px;
    margin: 12px 0 0 10px;
  }
}
.dow{
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding: 14px 30px;
  .dow_list{
    img{
      width: 34px;
      display: block;
      margin: 0 auto;
    }
    p{
      font-size: 14px;
      text-align: center;
    }
  }
}

/* 按钮组容器样式，用于控制按钮排列 */
.btn-group {
  width: 100%;
  margin: 40px auto 0;
  display: inline-flex; /* 让按钮在一行显示，也可用flex等，根据布局需求调整 */
  border: 1px solid #866638; /* 边框，模拟整体外框效果，可根据设计调整或去掉 */
  border-radius: 8px; /* 圆角，让外观更柔和 */
  overflow: hidden; /* 隐藏边框圆角外的内容，使按钮圆角和容器圆角融合 */

}

/* 通用按钮基础样式 */
.btn {
  width: 50%;
  padding: 8px 20px; /* 内边距，控制按钮大小 */
  border: none; /* 去掉默认边框 */
  background-color: transparent; /* 透明背景，方便区分不同状态 */
  cursor: pointer; /* 鼠标悬停显示手型，提示可点击 */
  font-size: 14px; /* 字体大小 */
  color: #866638; /* 字体颜色 */
}

/* 注册按钮样式 */
.register {
  background-color: #f5f5f5; /* 浅灰色背景，可根据设计调整 */
}

/* 登录按钮样式 */
.login {
  background-color: #866638; /* 模拟你图中的棕色，可根据实际色值调整 */
  color: #fff; /* 白色字体，与背景区分 */
}

.dow_list{
  position: relative;
}
._navCard_kghbt_30 .ui-badge--top-right {
    transform: translate(100%,-50%);
    right: .21rem;
    top: -.02rem;
    max-width: 1.2rem
}
.ui-badge--fixed {
    position: absolute;
    transform-origin: 100%;
}
.ui-badge {
    display: inline-block;
    box-sizing: border-box;
    // min-width: .48rem;
    padding: 1px 2px;
    color: #fff;
    text-align: center;
    background: #f93b3b;
    border-radius: 8px 14px 14px 0;
    font-size: 12px;
    font-weight: 400;
    font-stretch: normal;
    font-style: normal;
    line-height: 14px;
    letter-spacing: normal;
    overflow: visible;
    vertical-align: middle;
    position: absolute;
    right:-20px;
    top: -6px;
}
.ui-badge:before {
    content: "";
    display: inline-block;
    position: absolute;
    bottom: -.06rem;
    z-index: 20;
    left: 0;
    width: 0;
    height: 0;
    border-left: .079rem solid #f93b3b;
    border-top: .066rem solid transparent;
    border-bottom: .066rem solid transparent;
    font-size: 0;
}
.ui-badge__content {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    position: relative;
    z-index: 1;
    font-size: 12px;
    height: 14px;
    line-height: 14px;
    width: 30px;
}
.van-dialog__footer{
justify-content: space-around;
}
</style>



// WEBPACK FOOTER //
// src/components/mode/mine.vue